var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIconDark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.66333 15.241V12.5743H13.9967V15.241H0.66333ZM1.99666 11.241V8.74101L8.03 2.70767L10.53 5.20767L4.49666 11.241H1.99666ZM11.28 4.47434L8.78 1.97434L9.98 0.774339C10.1022 0.641006 10.2578 0.577006 10.4467 0.582339C10.6356 0.588117 10.7911 0.652117 10.9133 0.774339L12.48 2.34101C12.6022 2.46323 12.6633 2.61612 12.6633 2.79967C12.6633 2.98278 12.6022 3.14101 12.48 3.27434L11.28 4.47434Z",
    fill: "#465748"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconDark);
export default __webpack_public_path__ + "static/media/editIconDark.3e86440b7bd9efd2b11a189d200cacdb.svg";
export { ForwardRef as ReactComponent };